import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "card mb-20 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-md-20 d-flex align-items-center justify-content-between flex-wrap gap-3" }
const _hoisted_3 = { class: "d-flex align-items-center gap-4 flex-wrap" }
const _hoisted_4 = { class: "fs-20 pk-accent" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "fs-20 pk-accent" }
const _hoisted_7 = {
  key: 0,
  class: "text-center py-50 text-muted"
}
const _hoisted_8 = {
  key: 1,
  class: "card border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_9 = { class: "card-body p-30 text-center" }
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { class: "d-flex justify-content-center gap-2 flex-wrap" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_14 = { class: "col-12" }
const _hoisted_15 = { class: "alert pk-alert-ok mb-0" }
const _hoisted_16 = { class: "col-lg-5" }
const _hoisted_17 = { class: "card border rounded-0 bg-white h-100" }
const _hoisted_18 = { class: "card-body" }
const _hoisted_19 = { class: "border rounded-3 p-15 mb-15" }
const _hoisted_20 = { class: "fs-24 fw-bold text-center" }
const _hoisted_21 = { class: "fw-bold" }
const _hoisted_22 = { class: "d-flex justify-content-between mt-10" }
const _hoisted_23 = { class: "text-muted fs-13" }
const _hoisted_24 = { class: "col-lg-7" }
const _hoisted_25 = { class: "card pk-focus rounded-0 bg-white h-100" }
const _hoisted_26 = { class: "card-body" }
const _hoisted_27 = { class: "fs-13 text-muted" }
const _hoisted_28 = {
  key: 1,
  class: "row g-3"
}
const _hoisted_29 = { class: "col-lg-8" }
const _hoisted_30 = { class: "card border-0 rounded-0 bg-white h-100" }
const _hoisted_31 = { class: "card-body p-20" }
const _hoisted_32 = {
  key: 0,
  class: "alert alert-danger py-2 fs-13"
}
const _hoisted_33 = { class: "text-muted" }
const _hoisted_34 = { class: "row mb-15 fs-14" }
const _hoisted_35 = { class: "col-md-4" }
const _hoisted_36 = { class: "pk-accent" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "col-md-4" }
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { class: "table align-middle" }
const _hoisted_41 = { class: "d-flex align-items-center" }
const _hoisted_42 = ["src", "alt"]
const _hoisted_43 = { class: "text-muted fs-12" }
const _hoisted_44 = {
  key: 0,
  class: "badge pk-badge-ok"
}
const _hoisted_45 = {
  key: 1,
  class: "badge pk-badge-todo"
}
const _hoisted_46 = { class: "col-lg-4" }
const _hoisted_47 = { class: "card border-0 rounded-0 bg-white h-100" }
const _hoisted_48 = { class: "card-body p-20" }
const _hoisted_49 = { class: "mb-10" }
const _hoisted_50 = { class: "fs-36 fw-bold pk-accent" }
const _hoisted_51 = { class: "fs-20" }
const _hoisted_52 = {
  class: "progress mb-10",
  style: {"height":"10px"}
}
const _hoisted_53 = {
  key: 0,
  class: "mb-15"
}
const _hoisted_54 = { class: "text-danger" }
const _hoisted_55 = ["disabled"]
const _hoisted_56 = {
  key: 1,
  class: "text-muted fs-13 mb-15"
}
const _hoisted_57 = ["disabled"]
const _hoisted_58 = {
  class: "modal fade",
  id: "modal_packing_problem",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_59 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_60 = { class: "modal-content p-15 p-md-30" }
const _hoisted_61 = { class: "modal-body" }
const _hoisted_62 = { class: "modal-footer border-0 justify-content-center" }
const _hoisted_63 = ["disabled"]
const _hoisted_64 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "Poste d'emballage" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", null, [
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-muted me-2" }, "Bon", -1)),
            _createElementVNode("b", _hoisted_4, _toDisplayString(_ctx.refNote), 1)
          ]),
          (_ctx.state)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-muted me-2" }, "Colis", -1)),
                _createElementVNode("b", _hoisted_6, _toDisplayString(_ctx.state.done ? _ctx.state.total : _ctx.state.index) + " / " + _toDisplayString(_ctx.state.total), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline-secondary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.pause && _ctx.pause(...args)))
        }, _cache[16] || (_cache[16] = [
          _createElementVNode("i", { class: "ph ph-pause me-1" }, null, -1),
          _createTextVNode("Pause ", -1)
        ]))
      ])
    ]),
    (!_ctx.state)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, "Chargement..."))
      : (_ctx.state.done)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[19] || (_cache[19] = _createElementVNode("i", {
                class: "ph ph-check-circle pk-ok",
                style: {"font-size":"72px"}
              }, null, -1)),
              _cache[20] || (_cache[20] = _createElementVNode("h3", { class: "mt-10" }, "Tous les colis sont emballés", -1)),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.state.total) + " colis prêts pour le bon " + _toDisplayString(_ctx.refNote) + ".", 1),
              _createElementVNode("div", _hoisted_11, [
                (!_ctx.state.note.saved)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: "btn pk-btn",
                      disabled: _ctx.saving,
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveNote && _ctx.saveNote(...args)))
                    }, _cache[17] || (_cache[17] = [
                      _createElementVNode("i", { class: "ph ph-floppy-disk me-1" }, null, -1),
                      _createTextVNode("Enregistrer le bon ", -1)
                    ]), 8, _hoisted_12))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  class: "btn btn-outline-secondary",
                  to: "/packing"
                }, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode("Retour à la liste", -1)
                  ])),
                  _: 1,
                  __: [18]
                })
              ])
            ])
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            (_ctx.labelStep)
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[21] || (_cache[21] = _createElementVNode("i", { class: "ph ph-check-circle me-2" }, null, -1)),
                      _createTextVNode(" Tous les produits sont vérifiés — " + _toDisplayString(_ctx.state.parcel.scanned_qty) + " / " + _toDisplayString(_ctx.state.parcel.total_qty) + " pièces ", 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _cache[25] || (_cache[25] = _createElementVNode("h5", { class: "mb-15" }, "Étiquette imprimée", -1)),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.state.parcel.code), 1),
                          _cache[22] || (_cache[22] = _createElementVNode("hr", null, null, -1)),
                          _cache[23] || (_cache[23] = _createElementVNode("div", { class: "fs-13 text-muted" }, "Destinataire", -1)),
                          _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.state.parcel.receiver), 1),
                          _createElementVNode("div", null, _toDisplayString(_ctx.state.parcel.phone), 1),
                          _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.state.parcel.city_name), 1),
                            _createElementVNode("b", null, _toDisplayString(_ctx.state.parcel.price) + " " + _toDisplayString(_ctx.$devis), 1)
                          ]),
                          _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.state.parcel.address), 1)
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-primary w-100",
                          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.printLabel && _ctx.printLabel(...args)))
                        }, _cache[24] || (_cache[24] = [
                          _createElementVNode("i", { class: "ph ph-printer me-1" }, null, -1),
                          _createTextVNode("Réimprimer la même étiquette ", -1)
                        ]))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _cache[28] || (_cache[28] = _createElementVNode("h4", { class: "mb-15" }, [
                          _createElementVNode("i", { class: "ph ph-scan me-2 pk-accent" }),
                          _createTextVNode("Scannez l'étiquette collée sur le carton...")
                        ], -1)),
                        _withDirectives(_createElementVNode("input", {
                          ref: "labelInput",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.scan) = $event)),
                          type: "text",
                          class: "form-control form-control-lg pk-scan",
                          placeholder: "En attente du scan...",
                          autocomplete: "off",
                          onKeyup: _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitLabel && _ctx.submitLabel(...args)), ["enter"])),
                          onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.refocus && _ctx.refocus(...args)))
                        }, null, 544), [
                          [_vModelText, _ctx.scan]
                        ]),
                        (_ctx.message)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["mt-15 alert", _ctx.messageOk ? 'pk-alert-ok' : 'alert-danger'])
                            }, _toDisplayString(_ctx.message), 3))
                          : _createCommentVNode("", true),
                        _cache[29] || (_cache[29] = _createElementVNode("ol", { class: "mt-20 ps-20 text-muted" }, [
                          _createElementVNode("li", null, "Collez l'étiquette sur le carton"),
                          _createElementVNode("li", null, "Scannez le code du colis"),
                          _createElementVNode("li", null, "Le colis suivant s'affiche automatiquement")
                        ], -1)),
                        _createElementVNode("div", _hoisted_27, [
                          _cache[26] || (_cache[26] = _createTextVNode("Seule l'étiquette du colis ", -1)),
                          _createElementVNode("b", null, _toDisplayString(_ctx.state.parcel.code), 1),
                          _cache[27] || (_cache[27] = _createTextVNode(" est acceptée.", -1))
                        ])
                      ])
                    ])
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _cache[36] || (_cache[36] = _createElementVNode("h3", { class: "mb-15" }, "Scanner les produits", -1)),
                        (_ctx.state.parcel.problems && _ctx.state.parcel.problems.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _cache[30] || (_cache[30] = _createElementVNode("i", { class: "ph ph-warning me-1" }, null, -1)),
                              _cache[31] || (_cache[31] = _createElementVNode("b", null, "Problème signalé sur ce colis :", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.parcel.problems, (pr) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  key: pr.id,
                                  class: "d-block"
                                }, [
                                  _createTextVNode(_toDisplayString(pr.reason) + " ", 1),
                                  _createElementVNode("span", _hoisted_33, "(" + _toDisplayString(pr.reported_by_name) + ")", 1)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _cache[32] || (_cache[32] = _createElementVNode("span", { class: "text-muted d-block" }, "Colis actuel", -1)),
                            _createElementVNode("b", _hoisted_36, _toDisplayString(_ctx.state.parcel.code), 1)
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _cache[33] || (_cache[33] = _createElementVNode("span", { class: "text-muted d-block" }, "Client", -1)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.state.parcel.customer_name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_38, [
                            _cache[34] || (_cache[34] = _createElementVNode("span", { class: "text-muted d-block" }, "Destination", -1)),
                            _createElementVNode("b", null, _toDisplayString(_ctx.state.parcel.city_name), 1)
                          ])
                        ]),
                        _withDirectives(_createElementVNode("input", {
                          ref: "productInput",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.scan) = $event)),
                          type: "text",
                          class: "form-control form-control-lg pk-scan mb-10",
                          placeholder: "Scannez le code-barres du produit...",
                          autocomplete: "off",
                          disabled: _ctx.state.parcel.verified,
                          onKeyup: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.submitProduct && _ctx.submitProduct(...args)), ["enter"])),
                          onBlur: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.refocus && _ctx.refocus(...args)))
                        }, null, 40, _hoisted_39), [
                          [_vModelText, _ctx.scan]
                        ]),
                        (_ctx.message)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              class: _normalizeClass(["mb-10 alert py-2", _ctx.messageOk ? 'pk-alert-ok' : 'alert-danger'])
                            }, _toDisplayString(_ctx.message), 3))
                          : _createCommentVNode("", true),
                        _createElementVNode("table", _hoisted_40, [
                          _cache[35] || (_cache[35] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "#"),
                              _createElementVNode("th", null, "Produit"),
                              _createElementVNode("th", null, "Référence"),
                              _createElementVNode("th", null, "Emplacement"),
                              _createElementVNode("th", null, "Quantité scannée"),
                              _createElementVNode("th", null, "État")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.parcel.items, (it, i) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: it.id,
                                class: _normalizeClass({ 'pk-row-todo': it.scanned_qty < it.qnty })
                              }, [
                                _createElementVNode("td", null, _toDisplayString(i + 1), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_41, [
                                    _createElementVNode("img", {
                                      src: it.product_pic || _ctx.noImage,
                                      width: "56",
                                      height: "56",
                                      class: "rounded-2 border me-3 pk-thumb",
                                      alt: it.product_name,
                                      loading: "lazy"
                                    }, null, 8, _hoisted_42),
                                    _createElementVNode("div", null, [
                                      _createElementVNode("b", null, _toDisplayString(it.product_name), 1),
                                      _createElementVNode("div", _hoisted_43, _toDisplayString(it.variant_name), 1)
                                    ])
                                  ])
                                ]),
                                _createElementVNode("td", null, _toDisplayString(it.reference), 1),
                                _createElementVNode("td", null, _toDisplayString(it.location || "—"), 1),
                                _createElementVNode("td", null, [
                                  _createElementVNode("b", null, _toDisplayString(it.scanned_qty), 1),
                                  _createTextVNode(" sur " + _toDisplayString(it.qnty), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  (it.scanned_qty >= it.qnty)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_44, "Vérifié"))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_45, "À compléter"))
                                ])
                              ], 2))
                            }), 128))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_46, [
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _cache[41] || (_cache[41] = _createElementVNode("h5", null, "Progression du colis", -1)),
                        _createElementVNode("div", _hoisted_49, [
                          _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.state.parcel.scanned_qty), 1),
                          _createElementVNode("span", _hoisted_51, " / " + _toDisplayString(_ctx.state.parcel.total_qty), 1),
                          _cache[37] || (_cache[37] = _createElementVNode("span", { class: "fs-18 ms-1" }, "pièces scannées", -1))
                        ]),
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("div", {
                            class: "progress-bar pk-bar",
                            style: _normalizeStyle({ width: _ctx.parcelPercent + '%' })
                          }, null, 4)
                        ]),
                        (_ctx.state.parcel.remaining.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                              _cache[38] || (_cache[38] = _createTextVNode(" Il reste ", -1)),
                              _createElementVNode("b", _hoisted_54, _toDisplayString(_ctx.remainingQty) + " pièce" + _toDisplayString(_ctx.remainingQty > 1 ? "s" : ""), 1),
                              _createTextVNode(" : " + _toDisplayString(_ctx.state.parcel.remaining.map((r) => r.reference + (r.qty > 1 ? " ×" + r.qty : "")).join(", ")), 1)
                            ]))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn pk-btn w-100 mb-5",
                          disabled: !_ctx.state.parcel.verified,
                          onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.printLabelAndNext && _ctx.printLabelAndNext(...args)))
                        }, _cache[39] || (_cache[39] = [
                          _createElementVNode("i", { class: "ph ph-printer me-1" }, null, -1),
                          _createTextVNode("Imprimer l'étiquette ", -1)
                        ]), 8, _hoisted_55),
                        (!_ctx.state.parcel.verified)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, "Disponible lorsque tous les produits sont vérifiés."))
                          : _createCommentVNode("", true),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-outline-primary w-100 mb-10",
                          onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.problem && _ctx.problem(...args)))
                        }, _cache[40] || (_cache[40] = [
                          _createElementVNode("i", { class: "ph ph-warning me-1" }, null, -1),
                          _createTextVNode("Signaler un problème ", -1)
                        ])),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn btn-link text-muted w-100",
                          disabled: _ctx.state.parcel.scanned_qty === 0,
                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.reset && _ctx.reset(...args)))
                        }, " Recommencer ce colis ", 8, _hoisted_57),
                        _cache[42] || (_cache[42] = _createElementVNode("div", { class: "alert alert-info fs-13 mt-10 mb-0" }, "Produit incorrect ou quantité dépassée : scan refusé.", -1))
                      ])
                    ])
                  ])
                ]))
          ], 64)),
    _createElementVNode("div", _hoisted_58, [
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("div", _hoisted_60, [
          _cache[45] || (_cache[45] = _createElementVNode("div", { class: "modal-header border-0 justify-content-center" }, [
            _createElementVNode("h1", { class: "modal-title fs-4" }, "Signaler un problème")
          ], -1)),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_v_select, {
              modelValue: _ctx.problemReason,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.problemReason) = $event)),
              options: _ctx.problemReasons,
              clearable: false,
              searchable: false,
              placeholder: "Choisir un motif",
              class: "custom-select-height"
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_62, [
            _cache[44] || (_cache[44] = _createElementVNode("button", {
              type: "button",
              class: "btn btn-secondary",
              "data-bs-dismiss": "modal"
            }, "Annuler", -1)),
            _createElementVNode("button", {
              type: "button",
              class: "btn pk-btn",
              disabled: !_ctx.problemReason || _ctx.problemSaving,
              onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.submitProblem && _ctx.submitProblem(...args)))
            }, [
              (_ctx.problemSaving)
                ? (_openBlock(), _createElementBlock("span", _hoisted_64))
                : _createCommentVNode("", true),
              _cache[43] || (_cache[43] = _createTextVNode("Signaler ", -1))
            ], 8, _hoisted_63)
          ])
        ])
      ])
    ])
  ], 64))
}